import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { addSmartBannerIos } from './addSmartBannerIos';

export const redirectToApp = async () => {
    // TODO: revisar qué pasa con esto
    if (!Capacitor.isNativePlatform() && !window.location.href.includes('redirect-cobas-plus')) {
        const info = await Device.getInfo();
        if (info.operatingSystem.toLocaleLowerCase().includes('android')) {
            const baseURL = window.location.origin + window.location.pathname;
            const redirectURL = window.location.href.replace(baseURL, 'cobasapp://');
            window.location.href = redirectURL;
        } else if (info.operatingSystem.toLocaleLowerCase().includes('ios')) {
            addSmartBannerIos();
        }
    }
};
